// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RIQuestion-cls1__b1207103398f1cff8cc6{/*!*/}.RIQuestion-cls2___fc8bc0055cdb59b7405{margin-bottom:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "RIQuestion-cls1__b1207103398f1cff8cc6",
	"cls2": "RIQuestion-cls2___fc8bc0055cdb59b7405 RIQuestion-cls1__b1207103398f1cff8cc6"
};
export default ___CSS_LOADER_EXPORT___;
